import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import deleteIcon from 'src/assets/icons/deleteIcon.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiDeleteIcon: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.deleteIcon}
      component={deleteIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiDeleteIcon.displayName = 'DlMuiDeleteIcon';

const getStyles: GetStylesFunction = (options) => ({
  deleteIcon: css`
    width: 16px;
    height: 18px;
  `,
});
